const entries: Record<string, [string, string, string]> = {
  'section.stats': ['指标带', '指標帶', 'Key metrics'],
  'section.todos': ['待办事项', '待辦事項', 'To-do items'],
  'section.applications': [
    '最近申请动态',
    '最近申請動態',
    'Recent applications',
  ],
  'section.trend': ['趋势统计', '趨勢統計', 'Trends'],
  'section.composition': ['构成与占比', '構成與佔比', 'Composition'],
  'section.audits': ['系统审计日志', '系統審計日誌', 'Audit log'],
  'config.title': ['配置工作台', '配置工作台', 'Configure dashboard'],
  'config.reset': ['恢复出厂布局', '恢復出廠佈局', 'Restore default layout'],
  'config.metrics': [
    '指标（最多 5 项，按勾选顺序排列）',
    '指標（最多 5 項，按勾選順序排列）',
    'Metrics (up to 5, in selection order)',
  ],
  'config.defaultRange': ['默认时间', '預設時間', 'Default period'],
  'config.expiring': ['到期提醒', '到期提醒', 'Expiry reminders'],
  'config.days': ['{days} 天内', '{days} 天內', 'Within {days} days'],
  'config.applicationTypes': ['申请类型', '申請類型', 'Application types'],
  'config.size': ['显示条数', '顯示筆數', 'Rows to display'],
  'config.rows': ['{count} 条', '{count} 筆', '{count} rows'],
  'config.width': ['模块宽度', '模組寬度', 'Module width'],
  'config.half': ['半宽', '半寬', 'Half width'],
  'config.full': ['整行', '整行', 'Full width'],
  'config.up': ['上移', '上移', 'Move up'],
  'config.down': ['下移', '下移', 'Move down'],
  'empty.selection': [
    '请在配置中选择统计项',
    '請在配置中選擇統計項',
    'Choose data in dashboard settings',
  ],
  'empty.modules': [
    '工作台暂无可显示的模块',
    '工作台暫無可顯示的模組',
    'No dashboard modules selected',
  ],
  'stats.registeredPersons': ['注册人员', '註冊人員', 'Registered people'],
  'stats.registeredPersonsDesc': [
    '持有效注册身份，按人去重',
    '持有效註冊身份，按人去重',
    'People with a valid registration, deduplicated',
  ],
  'stats.yearRevenue': ['本年收入', '本年收入', 'Revenue this year'],
  'stats.yearRevenueDesc': [
    '本年 1 月 1 日起已入账收入',
    '本年 1 月 1 日起已入賬收入',
    'Posted income since 1 January',
  ],
  'stats.pendingApplications': [
    '待审核申请',
    '待審核申請',
    'Pending applications',
  ],
  'stats.pendingApplicationsDesc': [
    '你有权限审核的申请',
    '你有權限審核的申請',
    'Applications you can review',
  ],
  'stats.pendingOrders': ['待支付订单', '待支付訂單', 'Unpaid orders'],
  'stats.pendingOrdersDesc': [
    '等待缴费方付款',
    '等待繳費方付款',
    'Awaiting payer payment',
  ],
  'todo.membershipExpiringDays': [
    '会籍 {days} 天内到期',
    '會籍 {days} 天內到期',
    'Membership expiring within {days} days',
  ],
  'todo.qualificationExpiringDays': [
    '注册身份 {days} 天内到期',
    '註冊身份 {days} 天內到期',
    'Registration expiring within {days} days',
  ],
  'series.revenue': ['会费收入', '會費收入', 'Fee income'],
  'series.members': ['在籍会员', '在籍會員', 'Active members'],
  'series.registeredPersons': ['注册人员', '註冊人員', 'Registered people'],
  'series.quals': ['有效注册身份', '有效註冊身份', 'Valid registrations'],
  'series.committee': ['在任委员', '在任委員', 'Serving committee members'],
  'series.clubs': ['属会机构', '屬會機構', 'Affiliated clubs'],
  'dimension.revenue': ['收入构成', '收入構成', 'Revenue composition'],
  'dimension.identities': ['身份构成', '身份構成', 'Identity composition'],
  'dimension.memberTypes': ['会员类型构成', '會員類型構成', 'Membership types'],
  'dimension.qualTypes': ['注册类型构成', '註冊類型構成', 'Registration types'],
  'dimension.clubLevels': ['属会等级构成', '屬會等級構成', 'Club levels'],
  'range.week': ['本周', '本週', 'This week'],
  'range.month': ['本月', '本月', 'This month'],
  'range.year': ['本年', '本年', 'This year'],
  'range.m12': ['近 12 个月', '近 12 個月', 'Last 12 months'],
  'range.all': ['全部', '全部', 'All time'],
  'range.custom': ['自定义', '自訂', 'Custom'],
  'range.from': ['开始日期', '開始日期', 'Start date'],
  'range.to': ['结束日期', '結束日期', 'End date'],
  'chart.total': ['总计', '總計', 'Total'],
  refresh: ['刷新', '重新整理', 'Refresh'],
  'applicationType.club_settle': [
    '属会入驻申请',
    '屬會入駐申請',
    'Club settlement application',
  ],
  'applicationType.qual_clubjoin': [
    '加入属会申请',
    '加入屬會申請',
    'Club joining application',
  ],
  'applicationType.qual_transfer': [
    '转会申请',
    '轉會申請',
    'Transfer application',
  ],
  'applicationType.club_upgrade': [
    '属会升级申请',
    '屬會升級申請',
    'Club upgrade application',
  ],
  'applicationType.member_join': [
    '个人入会申请',
    '個人入會申請',
    'Membership application',
  ],
  'applicationType.club_join': [
    '属会入驻申请',
    '屬會入駐申請',
    'Club application',
  ],
  'applicationType.qual_reg': [
    '身份注册申请',
    '身份註冊申請',
    'Registration application',
  ],
  'applicationType.member_renew': [
    '会籍续期申请',
    '會籍續期申請',
    'Membership renewal',
  ],
  'applicationType.qual_renew': [
    '身份续期申请',
    '身份續期申請',
    'Registration renewal',
  ],
};

function messages(index: number): Record<string, string> {
  return Object.fromEntries(
    Object.entries(entries).map(([key, values]) => [
      `home.${key}`,
      values[index],
    ]),
  );
}

export const workbenchZhCN = messages(0);
export const workbenchZhHK = messages(1);
export const workbenchEnUS = messages(2);
